<main class="auth-page">
  <sz-brand-block [tagline]="'auth.welcome.tagline' | translate" />
  <auth-spectrum-accent />

  <div class="auth-head">
    <div class="auth-head__kicker">
      <span class="auth-head__live">{{ 'auth.welcome.kickerLive' | translate }}</span>
    </div>
    <h1 class="auth-head__title">
      {{ 'auth.welcome.titlePart1' | translate }}
      <span class="auth-head__accent">{{ 'auth.welcome.titlePart2' | translate }}</span
      ><br />
      <em>{{ 'auth.welcome.titlePart3' | translate }}</em>
    </h1>
    <p class="auth-head__lead">
      {{ 'auth.welcome.leadLine1' | translate }}<br />{{ 'auth.welcome.leadLine2' | translate }}
    </p>
  </div>

  <auth-google-sign-in-button
    [label]="'auth.common.googleContinue' | translate"
    [loading]="loading()"
    (clicked)="onGoogle()" />

  @if (showAppleSignIn) {
    <auth-apple-sign-in-button
      [label]="'auth.common.appleContinue' | translate"
      [loading]="loading()"
      (clicked)="onApple()" />
  }

  @if (errorMessage(); as msg) {
    <p class="auth-error" role="alert">{{ msg }}</p>
  }

  <auth-divider [label]="'auth.common.or' | translate" />

  <button type="button" class="cta cta--secondary" [disabled]="loading()" (click)="goToLogin()">
    <sz-icon name="mail" [size]="18" />
    <span>{{ 'auth.welcome.signInCta' | translate }}</span>
  </button>

  <div class="sep-label">
    <span class="sep-label__line" aria-hidden="true"></span>
    <span class="sep-label__text">{{ 'auth.welcome.noAccountLabel' | translate }}</span>
    <span class="sep-label__line" aria-hidden="true"></span>
  </div>

  <button type="button" class="cta cta--outline" [disabled]="loading()" (click)="goToRegister()">
    {{ 'auth.welcome.registerCta' | translate }}
  </button>

  <p class="legal">
    {{ 'auth.welcome.legalPrefix' | translate }}
    <a [routerLink]="termsPath">{{ 'auth.common.termsLink' | translate }}</a>
    {{ 'auth.common.and' | translate }}
    <a [routerLink]="privacyPath">{{ 'auth.common.privacyLink' | translate }}</a
    >{{ 'auth.welcome.legalSuffix' | translate }}
  </p>

  <div class="app-version">v{{ appVersion }}</div>
</main>
